export default {
  styles: {
    global: {
      "body.schedule-kiosk": {
        layerStyle: "kioskBody",
        "#root": {
          h: "100vh",
          w: "full",
          display: "flex",
          flexDirection: "column",
        },
      },
      // react-simple-keyboard
      ".hg-theme-default": {
        backgroundColor: "transparent !important",
        background: "transparent !important",
        ".hg-button[data-skbtn='{//}']": {
          background: "transparent",
          boxShadow: "none",
          border: "none",
          pointerEvents: "none",
        },
      },
    },
  },
};
